import React from "react";
import PrayerAppeal from "../components/PrayerAppeal";

export const HomePage: React.FC = () => {
  return <PrayerAppeal />;
};
